import { getFeatureEnabledForCountry } from '../../common/hooks/useGetFeatureEnabledForCountry';
import { getConfig } from '../../config';

export const getIsChatEnabled = () => {
  const { COUNTRY } = getConfig();
  return getFeatureEnabledForCountry(COUNTRY).isChatEnabled;
};
